import React, { useState, useEffect } from "react"

export const withAccordion = Component => ({
  name = "Accordion",
  active: externalActive = null,
  onClick = null,
  title = null,
  titleElement = null,
  handleRedirect = null,
  menuActive = null,
  ...props
}): JSX.Element => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (!menuActive) {
      setActive(false)
    }
  }, [menuActive])

  const isActive = onClick ? externalActive : active

  const handleActive = () => !onClick && setActive(!active)

  Component.displayName = name

  return (
    <Component
      {...props}
      active={isActive}
      handleActive={handleActive}
      setActive={setActive}
      title={title}
      titleElement={titleElement}
      onClick={onClick}
      handleRedirect={handleRedirect}
    />
  )
}
